import { useQuery } from '@tanstack/react-query'
import {
  arkiveringStatusHelpers,
  arkiveringStatusKeys,
} from '../queries/helpers'
import { arkiveringStatusApi } from '../queries/arkivering-status-api'

export const useArkiveringStatus = (kvitteringId: string) =>
  useQuery<IArkivRemote.ArchiveJob[], Error, IArkivRemote.ArchiveJob[]>({
    queryKey: arkiveringStatusKeys.get(kvitteringId),
    queryFn: async () => {
      const vars = arkiveringStatusHelpers.getArkiveringStatusVars(kvitteringId)

      if (
        !vars.noarksakAar ||
        !vars.noarksakSekvensnummer ||
        !vars.hoveddokumentId
      ) {
        return []
      }

      const { data } = await arkiveringStatusApi.getArkiveringStatus(vars)

      return data._embedded?.archiveJobs || []
    },
    enabled: !!kvitteringId,
  })
